import { Flags } from '@constants/flags';
import { useAllFlags } from '@hooks/flags';

export const useIsNewSubway = () => {
  const { flags } = useAllFlags();
  return flags[Flags.USER_GETS_NEW_SUBWAY];
};
